import React, { useEffect, useState } from 'react';
import {
  Box,
  CircularProgress,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTradesAction } from '../../store/actions/orders';
import TradeCards from './TradeCard';
import OrderDetailsDialog from '../Common/OrderDetailsDialog';
import { getOrderDetailFields } from '../../utils/orderDetailsConfig';
import GenericTable from '../Common/GenericTable';
import { tradesConfig } from '../../config/tableConfigs';
import { formatTimeToIST } from '../../utils/dateUtils';
import CommonMessages from '../Common/NoDataMessages';
import NoOrdersIllustration from '../Common/NoOrdersIllustration';

const Trades = () => {
  const trades = useSelector((state) => state.orders.arrTradesData);
  const [arrTrades, setArrTrades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [selectedOrder, setSelectedOrder] = useState(null);

  const handleCloseDetails = () => {
    setSelectedOrder(null);
  };

  const handleRowClick = (order) => {
    setSelectedOrder(order);
  };

  useEffect(() => {
    setArrTrades(trades);
    setLoading(false);
  }, [trades]);

  useEffect(() => {
    dispatch(fetchTradesAction());
  }, []);

  const formatTime = (timestamp) => {
    return formatTimeToIST(timestamp);
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          p: 3,
          backgroundColor: theme.palette.background.default,
        }}
      >
        <CircularProgress color="primary" />
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          p: 3,
          textAlign: "center",
          color: theme.palette.error.main,
          backgroundColor: theme.palette.background.default,
        }}
      >
        <Typography>{error}</Typography>
      </Box>
    );
  }

  return (
    <>
      {arrTrades.length === 0 ? (
        <CommonMessages
          icon={<NoOrdersIllustration />}
          messageHead="No trades found"
          messageBody="You have not placed any trades yet"
        />
      ) : isMobile ? (
        <TradeCards trades={arrTrades} tab="TRADE" />
      ) : (
        <GenericTable
          data={arrTrades}
          config={tradesConfig(isMobile)}
          onRowClick={handleRowClick}
          isMobile={isMobile}
        />
      )}

      {selectedOrder && (
        <OrderDetailsDialog
          order={selectedOrder}
          onClose={handleCloseDetails}
          isMobile={isMobile}
          detailFields={getOrderDetailFields(selectedOrder, formatTime, 'TRADE')}
          formatTime={formatTime}
          showRejectionReason={false}
        />
      )}
    </>
  );
};

export default Trades; 
